import {CODELOGIC_UI_PATH} from 'src/config';
export const HELP_IMAGE = <img
  style={{width: '500px'}}
  src={`${CODELOGIC_UI_PATH}/images/investigate-usages-animation.gif`}
/>;

